import {useTranslation} from 'react-i18next';

const useCheckFilterFieldsValdity = () => {
    const {t} = useTranslation();

    const handleCheckFieldValidity = (value, rules = []) => {
        let valid = true;
        let errors = [];

        for (const rule of rules) {
            switch (rule.type) {
                case `multiSelectMinItems`: {
                    if (true) {
                        const filterValue = rules.find(rule => rule.type === `multiSelectMinItems`).value;
                        const validity = value.length >= filterValue;
                        valid = valid && validity;
                        if (!validity) {
                            errors.push(`${t('Providers.filters-validation.multiSelectMinItems.p1')}${filterValue}${t('Providers.filters-validation.multiSelectMinItems.p2')}`)
                        }
                    }
                    break
                }
                case `multiSelectMaxItems`: {
                    if (true) {
                        const filterValue = rules.find(rule => rule.type === `multiSelectMaxItems`).value;
                        const validity = value.length <= filterValue;
                        valid = valid && validity;
                        if (!validity) {
                            errors.push(`${t('Providers.filters-validation.multiSelectMaxItems.p1')}${filterValue}${t('Providers.filters-validation.multiSelectMaxItems.p2')}`)
                        }
                    }
                    break
                }
                case `singleSelectNotEmpty`: {
                    if (true) {
                        const validity = value !== null;
                        valid = valid && validity;

                        if (!validity) {
                            errors.push(t('Providers.filters-validation.singleSelectNotEmpty'))
                        }
                    }
                    break
                }
                case `orderIsNotEmpty`: {
                    if (true) {
                        const validity = value !== null;
                        valid = valid && validity;

                        if (!validity) {
                            errors.push(t('Providers.filters-validation.orderIsNotEmpty'))
                        }
                    }
                    break
                }
                case `rangeFieldsOneIsNotEmpty`: {
                    if (true) {
                        const validity = value.upper !== '' || value.lower !== ''
                        valid = validity && valid

                        if (!validity) {
                            errors.push(t('Providers.filters-validation.rangeFieldsOneIsNotEmpty'));
                        } else {
                            for (const rule of rules) {
                                switch (rule.type) {
                                    case `rangeFieldsIsNumericalFloat`: {
                                        if (true) {
                                            const pattern = /^[+-]?\d+(\.\d+)?$/;
                                            const validity = (value.lower !== '' ? pattern.test(value.lower) : true) && (value.upper !== '' ? pattern.test(value.upper) : true);
                                            valid = validity && valid;
                                            if (!validity) {
                                                errors.push(t('Providers.filters-validation.rangeFieldsIsNumericalFloat'))
                                            } else {
                                                for (const rule of rules) {
                                                    switch (rule.type) {
                                                        case `rangeFieldsIsPositiveNumericalFloat`: {
                                                            if (true) {
                                                                const pattern = /^[+]?\d+(\.\d+)?$/;
                                                                const validity = (value.lower !== '' ? pattern.test(value.lower) : true) && (value.upper !== '' ? pattern.test(value.upper) : true);
                                                                valid = validity && valid;
                                                                if (!validity) {
                                                                    errors.push(t('Providers.filters-validation.rangeFieldsIsPositiveNumericalFloat'))
                                                                }
                                                            }
                                                            break
                                                        }
                                                        case `rangeFieldsLowerUpper`: {
                                                            if (true) {
                                                                const validity = value.lower !== '' && value.upper !== '' ? Number(value.lower) < Number(value.upper) : true;
                                                                valid = validity && valid;
                                                                if (!validity) {
                                                                    errors.push(t('Providers.filters-validation.rangeFieldsLowerUpper'))

                                                                }
                                                            }
                                                            break
                                                        }
                                                        default:
                                                            break
                                                    }
                                                }
                                            }
                                        }
                                        break
                                    }
                                    default:
                                        break
                                }
                            }
                        }
                    }
                    break
                }
                default:
                    break
            }
        }

        return {
            valid,
            errors
        }
    }

    return handleCheckFieldValidity;
}

export default useCheckFilterFieldsValdity;
